import Modal from "../Modal";
import OpportunityNewForm from "../../forms/opportunity/OpportunityNewForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function OpportunityNewModal({show, handleClose, items = null, title}) {
    const { t } = useTranslation();
    return (
        <Modal title={title} show={show} handleClose={handleClose}>
            <OpportunityNewForm handleClose={handleClose} items={items}/>
        </Modal>
    );
};